import axios from 'axios'
import ls from './ls'
import NProgress from 'nprogress'
var api = axios.create({
  baseURL: process.env.VUE_APP_API
});
console.log(process.env.VUE_APP_API);
api.defaults.headers.common['Authorization'] = 'Bearer ' + ls.get('token');
api.interceptors.request.use(config => {
  NProgress.start();
  const tok =ls.get('token');
  // console.log(ls.get('_u_unique'));
  if(config.method=='post'){
    config.data.session_user=ls.get('_u_unique');
  }else{
    config.params.session_user=ls.get('_u_unique');
  }
  if(tok==null){
    config.headers.Authorization=''
    }
    
    return config
})
api.interceptors.response.use(response =>{
  // console.log('preload hide');
  NProgress.done();
  return response
}, error => {
  const status = error.response ? error.response.status : null
  NProgress.done();
  if (status === 401) {
      ls.remove('token')
      ls.remove('_u_unique')
      ls.remove('_u_name')
      ls.remove('isLoggedIn')
      ls.remove('_u_unique_id')
      window.location.href="/login"
  }

  return Promise.reject(error);
})
export default api;
